<template>
  <ul class="navigation">
    <li
      v-for="(module, index) in modules"
      :key="index"
      class="navigation__item"
      :class="{ '--is-active': module.conf.id === active }"
      @click="$emit('openModule', module.conf.id)"
    >
      <span class="navigation__icon" v-html="module.conf.icon"></span>

      <span class="navigation__text" v-html="$store.getters.isB2b ? module.conf.name.b2b : module.conf.name.b2c"></span>

      <span
        v-if="module.conf.id === 'present' && $store.getters.getSelectedItem.data && $store.getters.getSelectedItem.data.type === 'level_3' && $store.getters.getSelectedItem.data.products.length > 0"
        class="navigation__notification-bubble"
      >
        {{ $store.getters.getSelectedItem.data.products.length }}
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Navigation',
  props: {
    modules: {
      type: Object
    },
    active: {
      type: String
    }
  },
  components: {
  }
};
</script>

<style lang="scss" scoped>
/**
 * Navigation
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Composer's tabbed navigation
 * @since 2022-04-06
**/

$component: 'navigation';

.#{$component} {
  @include unlist;

  display: flex;
  @include padding-left(map-get($spacers, 4));
  border-top-left-radius: $border-radius-lg;
  border-top-right-radius: $border-radius-lg;
  border-bottom: 1px solid $sky;
  @include linear-gradient(180deg, $sky-lighter, $sky-light);

  &__item {
    display: flex;
    align-items: center;
    // @include rfs(3.6rem, height);
    position: relative;
    @include padding(map-get($spacers, 3) map-get($spacers, 3));
    border-top: 3px solid transparent;
    border-right: 1px solid $sky;
    color: $ink-lighter;
    cursor: pointer;

    @include hover () {
      background-color: $sky-light;
      border-top-color: $sky-dark;
    }

    &:active {
      background-color: $sky;
    }

    &.--is-active {
      border-top-color: $primary;
      background-color: $white;
      color: $ink;

      .#{$component} {
        &__icon,
        &__icon svg {
          color: $ink;
        }
      }

      &:before,
      &:after {
        content: '';
        display: block;
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        pointer-events: none;
      }

      &:before {
        height: 10px;
        top: 0px;
        @include linear-gradient(180deg, darken($sky-light, 3%), transparent);
      }

      &:after {
        height: 1px;
        bottom: -1px;
        background-color: $white;
      }
    }

    &:first-child {
      border-left: 1px solid $sky;
    }
  }

  &__icon {
    @include rfs(1.3rem, width);
    @include margin-right(map-get($spacers, 2));

    svg {
      color: $ink-lighter;
    }
  }

  &__text {
    line-height: $line-height-base-sm;
  }

  &__notification-bubble {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    @include rfs(map-get($spacers, 1), right);
    @include rfs(map-get($spacers, 1), top);
    width: 18px;
    height: 18px;
    padding-right: 2px;
    border-radius: 50%;
    background-color: $primary;
    color: $white;
    line-height: 1;
    font-size: 11px;
    font-weight: $font-weight-bold;
    letter-spacing: -1px;
    text-align: center;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    // overflow-x: scroll;
    // scrollbar-width: none;

    // &::-webkit-scrollbar {
    //   display: none;
    // }

    &__item {
      // @include rfs(7rem, height);
      @include padding-right(map-get($spacers, 2));
      @include padding-left(map-get($spacers, 2));
    }

    &__notification-bubble {
      zoom: 0.8;
    }
  }
}
</style>
